import { useLanguageState } from "context/LanguageContext";

export const useErrorMessage = () => {
	const { getTranslate } = useLanguageState();

	const getTranslateError = (value?: string) => {
		if (!value) return "";

		const [word, ...values] = value.split(" ");

		return getTranslate(
			word,
			values?.reduce((acc, item, index) => ({ ...acc, [`value${index || ""}`]: item }), {}),
		);
	};

	return getTranslateError;
};
